// Package Block
import { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { DatePicker } from "antd";
import moment from "moment";

// Custom Components & Functions Block
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../../../../_metronic/_partials/controls";
import { NotificationTable } from "./NotificationTable";
import * as actions from "../../../../_redux/dashboard/dashboardActions";
import { dateStringApplyOffSet, getDateTimeInZone, getSettingKey } from "./../../../../../Common/utils";

export default function NotificationCard() {
  const [dateRange, setDateRange] = useState();
  const { currentState } = useSelector((state) => ({ currentState: state.basicSettings }), shallowEqual);
  const { entity } = currentState;
  const timezone = getSettingKey(entity, "Basic", "timezone");
  const [startDate, setStartDate] = useState(getDateTimeInZone(timezone)?.split("T")[0]);
  const [endDate, setEndDate] = useState(getDateTimeInZone(timezone)?.split("T")[0]);

  const dispatch = useDispatch();

  let params = {};


  const handleDatePicker = (date) => {
    params["start_date"] = dateStringApplyOffSet(date[0], timezone);
    params["end_date"] = dateStringApplyOffSet(date[1], timezone);
    dispatch(actions.fetchNotifications(params));
  };
  const { RangePicker } = DatePicker;
  return (
    <Card>
      <CardHeader title="Notifications">
        <CardHeaderToolbar>
          <div style={{ fontSize: "15px", marginRight: "20px" }}>
            <strong>Select Date Range:</strong>
          </div>
          <RangePicker
            ranges={{
              Today: [moment(getDateTimeInZone(timezone)?.split("T")[0]), moment(getDateTimeInZone(timezone)?.split("T")[0])],
              Yesterday: [
                moment(getDateTimeInZone(timezone)?.split("T")[0])?.subtract(1, "day"),
                moment(getDateTimeInZone(timezone)?.split("T")[0])?.subtract(1, "day"),
              ],
              "Last 7 Days": [moment(getDateTimeInZone(timezone)?.split("T")[0])?.subtract(7, "days"), moment(getDateTimeInZone(timezone)?.split("T")[0])],
              "Last 14 Days": [moment(getDateTimeInZone(timezone)?.split("T")[0])?.subtract(14, "days"), moment(getDateTimeInZone(timezone)?.split("T")[0])],
              "Last 30 Days": [moment(getDateTimeInZone(timezone)?.split("T")[0])?.subtract(30, "days"), moment(getDateTimeInZone(timezone)?.split("T")[0])],
            }}
            style={{ height: "34px" }}
            allowClear={false}
            format="MM-DD-YYYY"
            value={startDate && endDate ? [moment(startDate), moment(endDate)] : []}
            onChange={(dates, dateStrings) => {
              setDateRange(dateStrings);
              setStartDate(dateStrings[0]);
              setEndDate(dateStrings[1]);
              handleDatePicker(dateStrings);
            }}
          />
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <NotificationTable startDate={dateStringApplyOffSet(startDate, timezone)} endDate={dateStringApplyOffSet(endDate, timezone)} />
      </CardBody>
    </Card>
  );
}
